import React, { useState } from "react";

export default function SecondaryLogo({ slug }) {
  const BASE_URL = process.env.REACT_APP_BASE_URL_DEV;

  const secondaryLogo =
    `${BASE_URL}/forms/slug/${slug}/secondary-logo`;

  const [logoError, setLogoError] =
    useState(false);

  if (logoError) {
    return null;
  }

  return (
    <div className="vendor-logo-wrap">
    <img
      src={secondaryLogo}
      alt="Secondary Logo"
      className="secondary-logo"
      onError={() => setLogoError(true)}
    />
    </div>
   
  );
}